import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useNavigate } from 'react-router-dom';

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await api.get('/customers/');
        const data = response.data;

        // Handle both cases: array or wrapped object
        if (Array.isArray(data)) {
          setCustomers(data);
        } else if (data && Array.isArray(data.customers)) {
          setCustomers(data.customers);
        } else {
          console.error("Unexpected API response:", data);
          setCustomers([]);
        }
      } catch (err) {
        console.error("Failed to load customers", err);
        setError("Failed to load customers.");
        setCustomers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  if (loading) return <p>Loading customers...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Customer List</h2>
        <div className="d-flex gap-2">
          <button className="btn btn-primary" onClick={() => navigate("/dashboard/customers/new")}>
            + Add Customer
          </button>
          <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
        </div>
      </div>
      <table className="table table-bordered mt-3">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Type</th>
            <th>Country</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">No customers found.</td>
            </tr>
          ) : (
            customers.map((cust, index) => (
              <tr key={cust.id || index}>
                <td>{index + 1}</td>
                <td>{cust.full_name || '—'}</td>
                <td>{cust.email || '—'}</td>
                <td>{cust.phone_number || '—'}</td>
                <td>{cust.customer_type || '—'}</td>
                <td>{cust.residence_country || '—'}</td>
                <td>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-info text-white"
                      onClick={() => navigate(`/dashboard/customers/${cust.id}`)}
                      title="View Customer"
                    >
                      👁 View
                    </button>
                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => navigate(`/dashboard/customers/edit/${cust.id}`)}
                      title="Edit Customer"
                    >
                      ✏️ Edit
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerList;
